import React from "react";
// routing
import { NavLink } from "react-router-dom";
// @mui
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
// files
import { Navigation } from "./types";
import { Button } from "@src/components/Button/Button";
import { hasPermission } from "@src/utils/hasPermission";
import { ReactComponent as ArrowUpIcon } from "@src/assets/icons/navBarArrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "@src/assets/icons/navBarArrowDown.svg";

interface SidebarItemProps {
  nav: Navigation;
  activeNav: number;
  handleClassName: (isActive: boolean, id: number) => string;
  isCollapsed: boolean;
  navType?: "local" | "global";
}

export const SidebarItem: React.FC<SidebarItemProps> = ({
  nav,
  activeNav,
  handleClassName,
  navType = "local",
}) => {
  const isActiveNav = React.useMemo(() => {
    const checkSubNav = nav.subNav?.some((nav) => nav.id === activeNav);
    return checkSubNav || nav.id === activeNav;
  }, [activeNav]);
  const bgColor = isActiveNav ? "secondary" : "primary.main";

  return (
    <Box mb={"10px"} bgcolor={bgColor} padding={"10px"}>
      <NavLink
        onClick={() => {
          if (navType === "global") {
            const location = localStorage.getItem("currLocation");
            const group = localStorage.getItem("currRestGroupId");
            window.open(
              `https://admin.kwaaka.com/orders?group_id=${group}&restaurant_id=${location}`,
              "_self"
            );
          }
        }}
        to={nav.to}
        key={nav.id}
        className={({ isActive }) => handleClassName(isActive, nav.id)}
      >
        <Box display="flex" alignItems="center">
          <Box mr="18px" ml="4px">
            {React.cloneElement(nav.icon, {
              fill: activeNav === nav.id ? "#39d29f" : "#FFFFFF",
              color: activeNav === nav.id ? "text.secondary" : "#FFFFFF",
            })}
          </Box>
          <Typography
            width="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            variant="h4"
            ml="8px"
            color={activeNav === nav.id ? "text.secondary" : "common.white"}
            fontWeight="400"
          >
            <span>{nav.name}</span>

            <Button>
              {nav.subNav?.length ? (
                isActiveNav ? (
                  <ArrowUpIcon />
                ) : (
                  <ArrowDownIcon />
                )
              ) : null}
            </Button>
          </Typography>
        </Box>
      </NavLink>

      <Box>
        {nav.subNav?.length ? (
          <Collapse sx={{ padding: 0 }} in={isActiveNav} timeout="auto">
            <List sx={{ marginLeft: "50px" }}>
              {nav.subNav?.map((subItem) => {
                if (!hasPermission(subItem.role)) {
                  return null;
                }

                return (
                  <NavLink
                    key={subItem.id}
                    to={subItem.to}
                    className={({ isActive }) =>
                      handleClassName(isActive, subItem.id)
                    }
                  >
                    <Box mt="20px" width="190px">
                      <Typography
                        variant="h3"
                        width="190px"
                        display="flex"
                        flexWrap="wrap"
                        color={
                          activeNav === subItem.id
                            ? "text.secondary"
                            : "common.white"
                        }
                        fontWeight="400"
                        gap="5px"
                      >
                        {subItem.name.split(" ").map((text) => (
                          <span style={{}} key={text}>
                            &nbsp;{text}
                          </span>
                        ))}
                      </Typography>
                    </Box>
                  </NavLink>
                );
              })}
            </List>
          </Collapse>
        ) : null}
      </Box>
    </Box>
  );
};